import React from 'react';
import AppearanceTemplate from '../../components/templates/appearanceTemplate/appearanceTemplate';
import FormTemplate from '../../components/templates/formTemplate/formTemplate';
import ListTablePage from '../../components/templates/listTableTemplate/listTableTemplate';
import TabPage from '../../components/templates/tabPage/tabPage';
import ListTableTemplate from '../../components/templates/listTableTemplate/listTableTemplate';
import viewAppLayout from '../../config/viewAppCanvas';
import viewAppContent from '../../config/viewAppContent';
import viewAppContentForm from '../../config/viewAppContentFormWhiteLabel';
import viewAppProviders from '../../config/viewAppProvidersWhiteLabel';
import viewManualProvider from '../../config/viewManualProviderWhiteLabel';
import viewAppFeedback from '../../config/viewAppFeedback';
import viewAppTransactions from '../../config/viewAppTransactionsWhiteLabel';
import viewInfoSections from '../../config/viewInfoSections';
import viewAppDomains from '../../config/viewAppDomains';
import viewAppDictionaryItems from '../../config/viewAppDictionaryItems';
import viewAppConfig from '../../config/viewAppConfig';
import viewAppConfigForm from '../../config/viewAppConfigForm';
import viewAppClientConfig from '../../config/viewAppClientConfig';
import viewAppTagsWhiteLabel from '../../config/viewAppTagsWhiteLabel';
import viewAppDynamicProviders from '../../config/viewAppDynamicProviders';
import viewAppDynamicProvider from '../../config/viewAppDynamicProvider';
import viewAppDynamicProviderTokens from '../../config/viewAppDynamicProviderTokens';
import viewAppCategoriesBlackLabel from '../../config/viewAppCategoriesBlackLabel';
import viewTagsWhiteLabelEditForm from '../../config/viewTagsWhiteLabelEditForm';
import viewTagsWhiteLabelForm from '../../config/viewTagsWhiteLabelForm';
import viewAppConfigFormEdit from '../../config/viewAppConfigFormEdit';
import viewAppConfigFormNew from '../../config/viewAppConfigFormNew';
import routes, { getRoute } from '../../routes/route';

export const appManagerRoutes = [
  {
    path: (routes.APPEARANCE.path),
    element: <AppearanceTemplate />,
  },
  {
    path: (routes.CATEGORIES.path),
    element: <ListTablePage configFile={viewAppCategoriesBlackLabel} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_TAGS_WHITE_LABEL_NEW.path),
    element: <FormTemplate configFile={viewTagsWhiteLabelForm} />,
  },
  {
    path: (routes.APP_TAGS_WHITE_LABEL_EDIT.path),
    element: <FormTemplate configFile={viewTagsWhiteLabelEditForm} />,
  },
  {
    path: (routes.APP_TAGS_WHITE_LABEL.path),
    element: <ListTableTemplate configFile={viewAppTagsWhiteLabel} />,
  },
  {
    path: (routes.APP_LAYOUT.path),
    element: <FormTemplate configFile={viewAppLayout} />,
  },
  {
    path: routes.APP_CONTENT_EDIT.path,
    element: <FormTemplate configFile={viewAppContentForm} />,
  },
  {
    path: (routes.APP_CONTENT.path),
    element: <ListTablePage configFile={viewAppContent} />,
  },
  {
    path: (routes.APP_TRANSACTIONS.path),
    element: <TabPage configFile={viewAppTransactions} />,
  },
  {
    path: (routes.APP_PROVIDER_EDIT.path),
    element: <ListTablePage configFile={viewManualProvider} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_PROVIDERS.path),
    element: <ListTablePage configFile={viewAppProviders} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_FEEDBACK.path),
    element: <ListTablePage configFile={viewAppFeedback} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.INFO_SECTION.path),
    element: <FormTemplate configFile={viewInfoSections} />,
  },
  {
    path: (routes.DOMAINS.path),
    element: <ListTablePage configFile={viewAppDomains} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_DICTIONARY.path),
    element: <ListTablePage configFile={viewAppDictionaryItems} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.CONFIG_EDIT.path),
    element: <FormTemplate configFile={viewAppConfigFormEdit} />,
  },
  {
    path: (routes.CONFIG_NEW.path),
    element: <FormTemplate configFile={viewAppConfigFormNew} />,
  },
  {
    path: routes.CONFIG_RULES.path,
    element: <FormTemplate configFile={viewAppConfigForm} />,
  },
  {
    path: (routes.CONFIG.path),
    element: <ListTablePage configFile={viewAppConfig} onDelete={() => window.location.reload(false)} onCreate={() => window.location.reload(false)} withSessionVariables={['appId']} />,
  },
  {
    path: (routes.CLIENT_CONFIG.path),
    element: <FormTemplate configFile={viewAppClientConfig} />,
  },
  {
    path: (routes.APP_DYNAMIC_NEW.path),
    element: <FormTemplate configFile={viewAppDynamicProvider} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_DYNAMIC_TOKENS.path),
    element: <ListTablePage configFile={viewAppDynamicProviderTokens} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_DYNAMIC_EDIT.path),
    element: <FormTemplate configFile={viewAppDynamicProvider} withSessionVariables={['appId', 'areaId']} />,
  },
  {
    path: (routes.APP_DYNAMIC_PROVIDERS.path),
    element: <ListTablePage configFile={viewAppDynamicProviders} withSessionVariables={['appId', 'areaId']} />,
  },
];